export default __webpack_public_path__ + "static/canoeing-43a123b685799314d34308948ef1b64b.png";